// 回访设置
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -35px);">
          <vxe-grid
            :stripe="true" border="default" :row-config="{ isHover: true }" show-overflow height="100%"
            ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
            @custom="$vxeTableUtil.customHandle">

            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog" v-if="recallProjectAdd">新增
                  </vxe-button>
                </div>
                <div class="fr">
                  <!--									<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
                  <!--										status="primary" plain>重置</vxe-button>-->
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
              @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                <vxe-form-item title="名称:" field="name">
                  <template v-slot>
                    <el-input v-model="searchProjectName" size="small" clearable/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="编码:" field="name">
                  <template v-slot>
                    <el-input v-model="searchProjectCode" size="small" clearable/>
                  </template>
                </vxe-form-item>
              </vxe-form>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import editView from './edit.vue';
import {tableOption} from '@/const/crud/admin/tenant';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {indexPageMixins} from "@/mixins/tabChang";
import {mapGetters} from "vuex";

export default {
  name: 'visit',

  mixins: [indexPageMixins],
  components: {editView, pager},
  data() {
    return {
      recallProjectEdit: false,
      recallProjectAdd: false,
      total: 0,
      activeName: 'second',
      dataId: 0,
      pageSizes: [10, 20, 100],
      gridData: {},
      showEdit: false,
      editViewDataUpdateFlag: false,
      vxeOption: {},
      searchProjectCode: '',
      searchProjectName: '',
      // 查询参数
      formData: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        projectCode: '',
        projectName: ''
      },
    };
  },
  mounted() {
    // this.initTableList();
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    // activeName(newVal) {
    //   if (newVal === 'second' && this.editViewDataUpdateFlag) {
    //     this.initTableList()
    //   }
    // }
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.recallProjectEdit = this.permissions['recall_project_edit']
    this.recallProjectAdd = this.permissions['recall_project_add']
  },
  methods: {
    toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },

    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 分页功能
    changeTablePage(page, flag) {
      console.log('分页数据', page, this.formData)
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.getTableData();
    },
    // 搜索
    searchEvent() {
      this.formData.projectCode = this.searchProjectCode
      this.formData.projectName = this.searchProjectName
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()

    },
    // 重置
    resetEvent() {
      this.formData.searchCount = false
      this.formData.current = 1
      this.formData.projectCode = ''
      this.formData.projectName = ''
      this.searchProjectCode = ''
      this.searchProjectName = ''
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },
    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },
    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
    getTableData() {
      let that = this;
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: '/basic/basRecallProject/getListPage',
        param: this.formData,
        method: 'post',
        height: '800px',
        columns: [
          {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
          {
            title: '名称',
            field: 'projectName',
            width: 150,
            fixed: 'left'
          },
          {
            title: '编码',
            field: 'projectCode',
            width: 150,
          },
          {
            title: '值类型',
            field: 'valueType',
            width: 150,
            slots: {
              default: ({row}) => {
                if (row.valueType == 1) {
                  return [
                    <div>
                      <span>选项值</span>
                    </div>
                  ];
                } else if (row.valueType == 2) {
                  return [
                    <div>
                      <span>文本</span>
                    </div>
                  ];
                }
              }
            }
          },
          {
            title: '选项值',
            field: 'valueSplit',
            width: 150,
            slots: {
              default: ({row}) => {
                if (row.valueSplit == 1) {
                  return [
                    <div>
                      <span>审单</span>
                    </div>
                  ];
                } else if (row.valueSplit == 2) {
                  return [
                    <div>
                      <span>回访</span>
                    </div>
                  ];
                }
              }
            }
          },
          {
            title: '启用',
            field: 'usable',
            width: 150,
            slots: {
              default: ({row}) => {
                if (row.usable == 0) {
                  return [
                    <div class="txt-status disable">
                      <span>禁用</span>
                    </div>
                  ];
                } else if (row.usable == 1) {
                  return [
                    <div class="txt-status">
                      <span>启用</span>
                    </div>
                  ];
                }
              }
            }
          },


          {
            field: 'createTime',
            title: '创建时间',
            width: 150
          },
          {
            title: '创建人',
            field: 'createBy',
            width: 150,

          },
          {
            width: 47,
            fixed: 'right',
            title: '',
            sortable: false,
            slots: {
              default: ({row}) => {
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>
                  </div>
                ];
              }
            }
          }
        ]
      };
      // initVxeTable(tableOption).then(opts => {
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },
  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}</style>
